/// <reference path="../services/countryPicker.service.ts"/>
'use strict';

namespace ekh {
    interface ICardBinMessage {
        imgUrl: string;
        text: string;
    }

    class CardBinMessagesController {
        public messages: ICardBinMessage[] = [];
        public numberOfVisible: number;

        constructor(
            private bookingService: any
        ) {}

        $onInit() {
            this.bookingService.getCardDiscountsForDomain(
                TRPCONFIG.Domain.DomainId,
                TRPCONFIG.Domain.CultureCode
            )
                .then(({DiscountDetails}) => {
                    this.messages = DiscountDetails && DiscountDetails.Discount;
                    this.messages = this.sortArr(this.messages);
                })
                .catch(() => {
               this.messages = [];
           });
        }

        public showMore() {
            this.numberOfVisible = this.messages.length;
        }

        private sortArr(arr) {
            return arr.sort(({Highlight: highlightA}, {Highlight: highlightB}) => {
                return highlightA > highlightB ? -1 : 1;
            });
        }
    }

    angular
        .module('ekh')
        .component('cardBinMessages', {
            bindings:{
                numberOfVisible: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=CardBinMessages',
            controller: CardBinMessagesController,
            controllerAs: 'ctrl'
        });
}
